import { SelectedShippingRateSchema } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const buyReturnLabel = {
  name: "buyReturnLabel" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    shipmentRate: SelectedShippingRateSchema,
  }),
  output: z.object({
    success: z.boolean(),
    errorMessage: z.string().optional(),
  }),
};
